const apiUrl = import.meta.env.VITE_API_URL;
const mediaUrl = import.meta.env.VITE_MEDIA_URL;
const whatsappNumber = import.meta.env.VITE_WHATSAPP_NUMBER;

if (!apiUrl) {
  throw new Error("VITE_API_URL is not configured");
}

if (!mediaUrl) {
  throw new Error("VITE_MEDIA_URL is not configured");
}

export const env = {
  apiUrl,
  mediaUrl,
  whatsappNumber: whatsappNumber ?? ""
} as const;
